export default __webpack_public_path__ + "static/partnerIcon4-6b4f0fad342f14d801028989552cabea.svg";